import { createSelector } from 'reselect';

/**
 * GET API CALL
 *
 * Returns information about an API call
 *
 * @param {string}	type 	API Call type
 *
 * @return {array}	apiCallInfo	 Array: [isPending, hasError, errorCode, errorMessage]
 */
// eslint-disable-next-line import/prefer-default-export

export const getApiCalls = ({ apiCall }) => apiCall;
export const getApiCall = type =>
	createSelector(getApiCalls, apiCalls => {
		const apiCall = apiCalls[type];

		let error = false;
		if (!apiCall || typeof apiCall.error === 'undefined') {
			error = null;
		} else if (apiCall.error !== false) {
			error = true;
		}

		const apiCallInfo = [apiCall && apiCall.pending, error];

		if (apiCall && typeof apiCall.error !== 'undefined' && apiCall.error !== false) {
			if (apiCall.error.code) {
				apiCallInfo.push(apiCall.error.code);
			} else {
				apiCallInfo.push(0);
			}
			if (apiCall.error.description) {
				apiCallInfo.push(apiCall.error.description);
			} else {
				apiCallInfo.push(`${apiCall.error.message} in ${apiCall.error.config?.url} with data ${apiCall.error.config?.data}`);
			}
		} else {
			apiCallInfo.push(0);
			apiCallInfo.push('Unknown error...');
		}

		return apiCallInfo;
	});

export const getCombinedApiCall = types =>
	createSelector(getApiCalls, apiCalls => {
		let isPending = false;
		let errorCode = 0;
		let errorIsUndefined = false;
		let hasError = false;
		let errorMessage = '';

		for (let index = 0; index < types.length; index += 1) {
			const type = types[index];
			const apiCall = apiCalls[type];

			if (apiCall && apiCall.pending) {
				isPending = true;
			}

			if (!apiCall || typeof apiCall.error === 'undefined') {
				errorIsUndefined = true;
			}

			if (apiCall && typeof apiCall.error !== 'undefined' && apiCall.error !== false) {
				hasError = true;

				if (apiCall.error.code) {
					errorCode = apiCall.error.code;
				}

				if (apiCall.error.description) {
					errorMessage = apiCall.error.description;
				}

				if (apiCall.error.message) {
					errorMessage = `${apiCall.error.message} in ${apiCall.error.config?.url} with data ${apiCall.error.config?.data}`;
				}
			}
		}

		return [isPending, errorIsUndefined && !hasError ? null : hasError, errorCode, errorMessage];
	});
